module.exports = __webpack_public_path__ + "img/filter-icon.96ddcaca.svg";